import React, { useRef, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Badge, Container, CardBody, Card } from 'reactstrap';
import ControleTarefasPage from './controle-tarefas.page';
import { getUsuarioLocalStorage } from '../../localStorage.util';
import * as commonActions from '@common/common.action';
import WebapiCommon from '@common/util/webapi.common';
import CommonFunctions from '@common/util/functions.common';
import { controleTarefasEmum } from './controle-tarefas.utils';
import { PreviewHTML } from 'vivace-fluent-motion';
import { useReactToPrint } from 'react-to-print';
import RelatorioReceptaculos from './Recptaculos/Impressao';
import RelatorioImuno from './Imuno/Impressao';
import RelatorioLaminasCitologia from './Citologia/Impressao';
import RelatorioLaminasHistologia from './Histologia/Impressao';
import { useHistory } from 'react-router-dom';
import IntlMessage from '../../helpers/intlMessage';
import { useIntl } from 'react-intl';
import { changePeriod, getDate, obterListagemDePeriodos } from '../../helpers';

function ControleTarefasContainer ({ hideTitulo }) {
  const intl = useIntl();
  const componentRef = useRef();
  const dispatch = useDispatch();
  const history = useHistory();
  const dadosGeraisHospital = useSelector(state => state.commonReducer.dadosGeraisHospital);
  const [tipoRelatorio, setTipoRelatorio] = useState(0);
  const [dataRealizadoDe, setDataRealizadoDe] = useState('');
  const [dataRealizadoAte, setDataRealizadoAte] = useState('');
  const [cassetesCriadosNoPeriodo, setCassetesCriadosNoPeriodo] = useState([]);
  const [laminasCriadasNoPeriodo, setLaminasCriadasNoPeriodo] = useState([]);
  const [laminasCriadasNoPeriodoRelatorio, setLaminasCriadasNoPeriodoRelatorio] = useState([]);
  const [selectTipo, setSelectTipo] = useState(<IntlMessage id = "dashboards.taskControl.type"/>);
  const [previewHTML, setPreviewHTML] = useState(false);
  const [tipoPeriodo, setTipoPeriodo] = useState({ value: 'hoje', label: `${intl.formatMessage({ id: "period.today" })}` });
  const functionGetDate = getDate.bind(this);
	const functionChangePeriod = changePeriod.bind(this);
  const functionObterListagemDePeriodos = obterListagemDePeriodos.bind(this);
  const periodos = functionObterListagemDePeriodos(intl);

  useEffect(() => {
    let usuarioLocalStorage = getUsuarioLocalStorage();
    if (usuarioLocalStorage === null) {
      history.push('/' + process.env.REACT_APP_LOGINPAGE);
    } else {
      dispatch(commonActions.showFadeCarregando(false));
    }
    obterPeriodoFiltroInicializacao();
    periodoAlterado(tipoPeriodo);
  }, []);

  const obterPeriodoFiltroInicializacao = () => {
    const periodo = CommonFunctions.getPeriodosSubDaysTime(0);
    setDataRealizadoDe(periodo.periodoInicial);
    setDataRealizadoAte(periodo.periodoFinal);
  };

  const changeSelectTipo = (el, tipo) => {
    if (tipo === controleTarefasEmum.RECEPTACULOS) {
      setCassetesCriadosNoPeriodo([]);
    } else {
      setLaminasCriadasNoPeriodo([]);
      setLaminasCriadasNoPeriodoRelatorio([]);
    }

    setSelectTipo(el);
    setTipoRelatorio(tipo);
  };

  const atualizarDataRealizacao = (nome, data) => {
    if (nome === 'dataRealizadoDe') {
      setDataRealizadoDe(data);
    } else {
      setDataRealizadoAte(data);
    }
  };

  const gerarRelatorio = () => {
    const result = CommonFunctions.validaData(dataRealizadoDe, dataRealizadoAte, intl);

    if (!result.valid) {
      dispatch(commonActions.showAlerta('alerta', result.message, 3000));
      return;
    }

    dispatch(commonActions.showFadeCarregando(true));
    Promise.all([
      tipoRelatorio === controleTarefasEmum.RECEPTACULOS &&
        WebapiCommon.getLaudoBlocosControleReceptaculo(dataRealizadoDe, dataRealizadoAte),
      tipoRelatorio === controleTarefasEmum.IMUNO &&
        WebapiCommon.getLaudoBlocosControleImuno(dataRealizadoDe, dataRealizadoAte),
      tipoRelatorio === controleTarefasEmum.LAMINAS_CITOLOGIA &&
        WebapiCommon.getLaudoBlocosControleLaminasCitologia(dataRealizadoDe, dataRealizadoAte),
      tipoRelatorio === controleTarefasEmum.LAMINAS_HISTOLOGIA &&
        WebapiCommon.getLaudoBlocosControleLaminasHistologia(dataRealizadoDe, dataRealizadoAte)
    ]).then(res => {
      const mensagem = <IntlMessage id = "dashboards.taskControl.dataSucessfully"/>
      dispatch(commonActions.showAlerta('sucesso', mensagem, 10));

      const [responseReceptaculos, responseImuno, responseCitologia, responseHistologia] = res;

      if (tipoRelatorio === controleTarefasEmum.RECEPTACULOS) {
        const dataFormated = responseReceptaculos.data.map(item => ({
          ...item,
          urgencia: item.urgencia ? <IntlMessage id = "dashboards.taskControl.itemUrgenciaYes"/> : <IntlMessage id = "dashboards.taskControl.itemUrgenciaNo"/>,
          novosCortes: item.novosCortes ? <IntlMessage id = "dashboards.taskControl.itemNCYes"/> : <IntlMessage id = "dashboards.taskControl.itemNCNo"/>
        }));
        setCassetesCriadosNoPeriodo(dataFormated);
      }

      if (tipoRelatorio === controleTarefasEmum.IMUNO) {
        const { data } = responseImuno;
        setLaminasCriadasNoPeriodoRelatorio(data);

        let arrayDataFormated = [];
        data.map(item => (arrayDataFormated = [...arrayDataFormated, ...item]));
        arrayDataFormated = arrayDataFormated.map(dataItem => ({
          ...dataItem,
          datafinalizacaoFormated: CommonFunctions.formatDate(
            dataItem.datafinalizacao
          ),
          anticorposFormated: (
            <Badge color='primary' className='badge-reagente'>
              <Badge color='link'>{dataItem.anticorpos}</Badge>
              <Badge color='dark'>{dataItem.tipoAnticorpo}</Badge>
            </Badge>
          )
        }));

        setLaminasCriadasNoPeriodo(arrayDataFormated);
      }

      if (tipoRelatorio === controleTarefasEmum.LAMINAS_CITOLOGIA) {
        const dataFormated = responseCitologia.data.map(item => ({
          ...item,
          cancelada: item.cancelada ? <IntlMessage id = "dashboards.taskControl.itemNCYes"/> : <IntlMessage id = "dashboards.taskControl.itemNCNo"/>
        }));
        setLaminasCriadasNoPeriodoRelatorio(dataFormated);
        setLaminasCriadasNoPeriodo(dataFormated);
      }

      if (tipoRelatorio === controleTarefasEmum.LAMINAS_HISTOLOGIA) {
        const dataFormated = responseHistologia.data.map(item => ({
          ...item,
          cancelada: item.laminaCancelada ? <IntlMessage id = "dashboards.taskControl.itemNCYes"/> : <IntlMessage id = "dashboards.taskControl.itemNCNo"/>
        }));
        setLaminasCriadasNoPeriodoRelatorio(dataFormated);
        setLaminasCriadasNoPeriodo(dataFormated);
      }

      dispatch(commonActions.showFadeCarregando(false));
    });
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: dadosGeraisHospital.razaosoc
  });

	function resetarPeriodo() {
		setTipoPeriodo('');
	}

	function periodoAlterado(e) {
		if (!e || !e.value) {
		  return resetarPeriodo();
		}

		let payload = functionGetDate(e.value);
		payload.dtinicial = payload.dtinicial.toISOString().slice(0, 10);
		payload.dtfinal = payload.dtfinal.toISOString().slice(0, 10);

    setTipoPeriodo(e);
    setDataRealizadoDe(payload.dtinicial);
    setDataRealizadoAte(payload.dtfinal);
	}

	function mudarIntervaloPeriodo(val) {
		let payload = functionChangePeriod(val);

    setDataRealizadoDe(payload.start);
    setDataRealizadoAte(payload.end);
	}

	function eventoOnKeyPressData(event) {
		if (event.key === "Enter")
			gerarRelatorio();
	}

  const ComponentHTML = ({ id }) => {
    return (
      <div className='mv-visualizador-html'>
        <Card id={id}>
          <CardBody>
            <Container fluid>
              <div ref={componentRef}>
                {tipoRelatorio === controleTarefasEmum.RECEPTACULOS && (
                  <RelatorioReceptaculos lista={cassetesCriadosNoPeriodo} />
                )}
                {tipoRelatorio === controleTarefasEmum.IMUNO && (
                  <RelatorioImuno lista={laminasCriadasNoPeriodoRelatorio} />
                )}
                {tipoRelatorio === controleTarefasEmum.LAMINAS_CITOLOGIA && (
                  <RelatorioLaminasCitologia lista={laminasCriadasNoPeriodoRelatorio} />
                )}
                {tipoRelatorio === controleTarefasEmum.LAMINAS_HISTOLOGIA && (
                  <RelatorioLaminasHistologia lista={laminasCriadasNoPeriodoRelatorio} />
                )}
              </div>
            </Container>
          </CardBody>
        </Card>
      </div>
    );
  };

  return (
    <div>
      <PreviewHTML
        messageTitle = {<IntlMessage id = "dashboards.reports.printPreview"/>}
        printLabel = {<IntlMessage id = "dashboards.reports.printOut"/>}
        visible={previewHTML}
        id='uniqueID'
        component={<ComponentHTML id='uniqueID' />}
        onOpened={e => setPreviewHTML(e)}
        onPrint={handlePrint}
      />

      <ControleTarefasPage
        hideTitulo={hideTitulo}
        setPreviewHTML={setPreviewHTML}
        dataRealizadoDe={dataRealizadoDe}
        dataRealizadoAte={dataRealizadoAte}
        atualizarDataRealizacao={atualizarDataRealizacao}
        gerarRelatorio={gerarRelatorio}
        cassetesCriadosNoPeriodo={cassetesCriadosNoPeriodo}
        laminasCriadasNoPeriodo={laminasCriadasNoPeriodo}
        changeSelectTipo={changeSelectTipo}
        selectTipo={selectTipo}
        tipoRelatorio={tipoRelatorio}
        periodos={periodos}
				periodo={tipoPeriodo}
				onChangePeriodo={periodoAlterado}
				mudarIntervaloPeriodo={mudarIntervaloPeriodo}
				onKeyPressData={eventoOnKeyPressData}
      />
    </div>
  );
}

export default ControleTarefasContainer;



// WEBPACK FOOTER //
// ./src/pages/controleTarefas/controle-tarefas.container.js